import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';

const AdminRoute: React.FC = () => {
  const { user } = useUser();

  if (!user) {
    // No user data, redirect to login
    return <Navigate to="/login" replace />;
  }
  const role = (user.Role || user.role || '').toLowerCase();
  
  // Internal staff roles that can access admin routes (case-insensitive)
  const internalStaffRoles = ['admin', 'manager', 'user'];
  const isInternalStaff = internalStaffRoles.includes(role);

  if (!isInternalStaff) {
    // User is not internal staff (Client, Client Admin, Rep), redirect to appropriate area
    console.log('AdminRoute - redirecting non-internal user with role:', role);
    if (role === 'client' || role === 'client admin' || role === 'clinic admin' || role === 'clinic user') {
      return <Navigate to="/client/patients" replace />;
    }
    if (role === 'distributor' || role === 'distributor admin' || role === 'distributor rep') {
      return <Navigate to="/distributor/dashboard" replace />;
    }
    if (role === 'org admin' || role === 'org rep') {
      return <Navigate to="/org/dashboard" replace />;
    }
    if (role === 'rep') {
      return <Navigate to="/rep/crm" replace />;
    }
    return <Navigate to="/login" replace />;
  }

  // User is authenticated and is internal staff, allow access
  return <Outlet />;
};

export default AdminRoute; 